import { css } from "lit";

export const formSectionStyles = css`
  .form-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    --wow-input-label-color: var(--sds-color-text-default-tertiary);
  }

  .form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: flex-start;
  }

  .form-row > * {
    flex: 1 1 140px;
  }
`;
